import React, { useState, useEffect, useRef } from "react";
import imgCpfLogo from "../images/cpf-logo.svg";
import axios from "axios";
import { env } from "../../env";
import { store } from "redux/store";
import { setIsLogin, setTokenisedId } from "redux/signPassIdentify";
import { setIsOpen, setIsOpenedSideBar } from "redux/header";
import { changeNric } from "redux/appointment";
import { useSelector, useDispatch, batch } from "react-redux";
import { getBannerText } from "services/api-service";
import { useOutsideClickDetection } from "utils/common";

import { Link } from "react-router-dom";
import { DEFAULT_ROUTE } from "constants/route";

import { Modal } from "react-bootstrap";
import moment from "moment";
// import { refreshOtpToken } from "services/api-service2";

const TimeoutModal = ({ show, logout, continueSession }) => {
  return <Modal show={show}>
      <Modal.Header className="bg-button-color" closeButton={false} />
      <Modal.Body className="p-3">
              {/* <div className={"text-center"}>
                <i
                  className={`icon-dls-warning-solid icon-big`}
                  style={{ color: "#a46200", fontSize: 80 }}
                  aria-hidden="true"></i>
                {error}
              </div> */}
        <div className="cmp-modal__content text-center" style={{color:"#134f4e"}} >
          <div className="cmp-modal__icon">
            <span className="icon-dls-warning-solid"
                      style={{ color: "#b7760d", fontSize: 80 }}
            ></span>
          </div>
          <div>
            <h4 className="title__text title__text--semi-bold" style={{paddingBottom: 16}}>
              Your session is about to time out.
            </h4>
            <p className="cmp-modal__content--cta" style={{fontWeight:600}}>
              You have been inactive for a while. Would you like to log out or continue?
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <div className="cmp-modal__cta">
          <button className="cmp-button cmp-button--secondary cmp-button--cancel" onClick={logout}>
            <span className="cmp-button__text"> Log out </span>
          </button>
          &nbsp;&nbsp;&nbsp;
          <button className="cmp-button cmp-button--primary cmp-button--ok" onClick={continueSession}>
            <span className="cmp-button__text"> Continue </span>
          </button>
        </div>
     </Modal.Footer>
   </Modal>
}

export default function Header({ loginRequired = true }) {
  const dispatch = useDispatch();
  const dropDownClose = useRef(null);
  const [menuAnimateCss, setMenuAnimateCss] = useState("");
  const [menuShowCss, setMenuShowCss] = useState("");
  const [bannerText, setBannerText] = useState("");
  const [isOpenedMember, setIsOpenedMember] = useState(false);
  const [isOpenedBanner, setIsOpenedBanner] = useState(false);

  const { isOpen, isOpenedSideBar } = useSelector((state) => state.header);

  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const [screenWidth, setScreenWidth] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [profileInfo, setProfileInfo] = useState({});

  const refProfileMenuDesktop = useRef(null);
  const refProfileMenuMobile = useRef(null);

  const [expInSeconds, setExpInSeconds] = useState(null); // uinfo's expInSeconds
  const [hasRefreshToken, setHasRefreshToken] = useState(false); 
  const {
    otpToken,
  } = useSelector((state) => state.xAppointment);


  // Close the menu when click outside of the profile menu.
  useOutsideClickDetection(refProfileMenuDesktop, () => {
    setIsProfileOpen(false);
  });

  useOutsideClickDetection(refProfileMenuMobile, () => {
    setIsProfileOpen(false);
  });

  const isMobile = screenWidth < 992;
  const refSearchInput = useRef();

  const fetchUinfo = (onLogin = null) => {
    axios
      .get(`${env.apiUrl}/api/sp/uinfo`, {
        withCredentials: true
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.uid) {
          store.dispatch(setIsLogin(true));
          store.dispatch(changeNric(res.data.uid));
          store.dispatch(setTokenisedId(res.data.tokenisedId));
          setProfileInfo({
            name: res.data.name,
            lastLoginTime: res.data.lastLoginTime
          });
          onLogin && onLogin(res.data);
        } else {
          // No session clear auth session data
          store.dispatch(setIsLogin(false));
          store.dispatch(changeNric(null));
          store.dispatch(setTokenisedId(null));
          setProfileInfo({});
        }
      });
  };

  const refreshToken = ()=> {
    axios
        .get(`${env.apiUrl}/api/sp/refreshToken`, {
          withCredentials: true
        })
        .then((res) => {
          console.log(res.data);
          // to cause the expInSeconds to be updated
          fetchUinfo((resData) => {
              const { expInSeconds } = resData;
              setExpInSeconds(expInSeconds);
              setHasRefreshToken(x=>!x);
          });

          if (res.data.status === "ERROR") {
            batch(()=>{
              dispatch(setIsLogin(false));
              dispatch(changeNric(null));
              dispatch(setTokenisedId(null));
            });
          }
    });
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // if (isOpen) return;
    console.log("##header");

    getBannerText().then((r) => {
      const { data: response } = r;
      if (response.data) {
        setBannerText(response.data.bannerText);
      }
    });

    // Check login status
    fetchUinfo((resData) => {
        const { expInSeconds } = resData;
        setExpInSeconds(expInSeconds);
        setHasRefreshToken(x=>!x);
    });
  }, []);

  // watch hasRefreshToken
  useEffect(() => {
    console.log("timeout", {expInSeconds, hasRefreshToken});

    let _refreshTokenTimeout = null;

    const clear = () => {
      if (_refreshTokenTimeout) {
        clearTimeout(_refreshTokenTimeout);
      }
    }

    if (expInSeconds) {

      const autoRefreshAt =  (expInSeconds - window.refreshTokenBeforeExpirySeconds /* 60 secs */) * 1000;
 
      _refreshTokenTimeout = setTimeout(() => {
        refreshToken(); // silent refresh
      }, autoRefreshAt);

      console.log("timeout", "autoRefreshAt sp", autoRefreshAt, 
        moment().add((expInSeconds  - window.refreshTokenBeforeExpirySeconds), "seconds").format("HH:mm:ss"));
      console.log("timeout", "expAt sp",
        moment().add(expInSeconds, "seconds").format("HH:mm:ss"));

    } else {
      clear(); 
    }
    return () => {
      clear(); 
    };
  }, [expInSeconds, hasRefreshToken]);

  useEffect(() => {
    function handleResize() {
      setScreenWidth(window.innerWidth);
    }
    const closeDropDown = (e) => {
      if (dropDownClose.current && isOpenedMember && !dropDownClose.current.contains(e.target)) {
        setIsOpenedMember(false);
      }
    };
    document.addEventListener("mousedown", closeDropDown);
    window.addEventListener("resize", handleResize);
    return () => {
      document.removeEventListener("mousedown", closeDropDown);
      window.removeEventListener("resize", handleResize);
    };
  }, [isOpenedMember]);

  useEffect(() => {
    if(isMobile) {
      dispatch(setIsOpenedSideBar(false));
      setMenuAnimateCss("animate__animated animate__slideOutRight");
      setTimeout(() => {
        setMenuShowCss("");
        setMenuAnimateCss("");
      }, 600);
    }
  }, [isMobile]);

  const clkMenuBurger = () => {
    const _isMobileMenuOpen = !isOpenedSideBar;

    if (_isMobileMenuOpen) {
      setIsOpenedBanner(true);
      setMenuAnimateCss("animate__animated animate__slideInRight");
      setMenuShowCss("show");
      setTimeout(() => {
        dispatch(setIsOpenedSideBar(_isMobileMenuOpen));
        setMenuAnimateCss("");
      }, 600);
    } else {
      dispatch(setIsOpenedSideBar(_isMobileMenuOpen));
      setMenuAnimateCss("animate__animated animate__slideOutRight");
      setTimeout(() => {
        setIsOpenedBanner(false);
        setMenuShowCss("");
        setMenuAnimateCss("");
      }, 600);
    }

    // setMenuAnimateCss(
    //   menuOpenClass === ""
    //     ? "animate__animated animate__slideInRight"
    //     : "animate__animated animate__slideOutRight"
    // );
  };

  const handleCloseBanner = () => dispatch(setIsOpen(false));

  const handleOpenMember = () => setIsOpenedMember(!isOpenedMember);

  const login = () => {
    if (window.appMode === "DEV") {
      const visitorIdentity = window.prompt("ID", "S1234567D");
      if (visitorIdentity == null) return;
      axios
        .post(
          `${env.apiUrl}/api/sp/simulate/login`,
          { visitorIdentity },
          {
            withCredentials: true
          }
        )
        .then((res) => {
          // store.dispatch(setIsLogin(true));
          fetchUinfo();
          console.log(res.data);
        });
    } else {
      // UAT or PROD
      window.location.href = window.mainLoginUrl2;
    }
  };

  const logout = () => {
    if (window.appMode === "DEV") {
      axios
        .post(
          `${env.apiUrl}/api/sp/simulate/logout`,
          {},
          {
            withCredentials: true
          }
        )
        .then((res) => {
          // store.dispatch(setIsLogin(false));
          fetchUinfo();
          console.log(res.data);
        });
    } else {
      // UAT or PROD
      window.location.href = window.mainLogoutUrl;
    }
  };
  const access = () => {
    axios
      .get(`${env.apiUrl}/api/sp/simulate/accessProtectedResource`, {
        withCredentials: true
      })
      .then((res) => {
        console.log(res.data);
      });
  };

  const handleCloseSearch = () => {
    setIsOpenSearch(!isOpenSearch);
    console.log("refSearchInput", refSearchInput);
    setTimeout(() => refSearchInput.current.focus(), 100);
  };

  const handleChangeSearch = (e) => setSearchValue(e.target.value);

  const handleSearch = (e) => {
    e.preventDefault();
    // eslint-disable-next-line no-restricted-globals
    location.href = window.searchUrl.replace("{sourceUrl}", window.location.href).replace("{queryString}", searchValue);
  };

  return (
    <header
      className="header"
      data-site-section-id="Global Header"
      data-show-postlogin="true"
      data-resource-path="/member/_jcr_content/header">
      {isOpen && !isOpenedBanner && bannerText && (
        <div className="announcement-bar">
          <div>{bannerText}</div>
          <div className="cursor-pointer p-2" onClick={handleCloseBanner}>
            X
          </div>
        </div>
      )}
      <div>
        {/* <div className="global-header-compliance">
          <div className="aem-Grid aem-Grid--default--12 base-print-grid">
            <div className="aem-GridColumn aem-GridColumn--default--12">
              <div className="global-header-compliance__container">
                <a
                  className="global-header-compliance__text"
                  aria-label="A Singapore Government Agency Website"
                  href="https://www.gov.sg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span
                    className="icon-gov-compliance"
                    style={{ lineHeight: 24 }}
                  ></span>
                  <span>A Singapore Government Agency Website</span>
                </a>
              </div>
            </div>
          </div>
        </div> */}

        <div
          className="global-header-navbar global-header-navbar--member"
          data-resourcepath="/content/web/sg/en/member/logout">
          <div className="global-header-navbar__container">
            <div className="aem-Grid aem-Grid--default--12 base-print-grid">
              <div className="aem-GridColumn aem-GridColumn--default--12">
                <div className="global-header-navbar__wrapper">
                  <div className="global-header-navbar__brand">
                    <div className="global-header-navbar__left-menu">
                      <a
                        className="global-header-navbar__item global-header-navbar__item-active"
                        // href={`${process.env.PUBLIC_URL}/service`}
                        href={"https://www.cpf.gov.sg"}
                        target="_self"
                        data-analytics-click-id="GlobalHeaderLogo"
                        data-analytics-text=""
                        data-analytics-section="Global Header"
                        aria-label="Central Provident Fund Board logo"
                        style={{ paddingTop: 13, paddingBottom: 13 }}>
                        {/* <img src="/content/dam/web/global/global-header/cpf-logo.svg" alt="Central Provident Fund Board logo"> */}

                        <img src={imgCpfLogo} className="cpfLogo" alt="CPF Board" />
                      </a>
                    </div>
                    <div className="global-header-navbar__right-menu">
                      {loginRequired && !isLogin && (
                        <div className="global-header-navbar__item global-header-navbar__item--login global-header-navbar__item--login-pre">
                          <div className="button" onClick={isLogin ? logout : login}>
                            <a
                              className="cmp-button"
                              aria-label="Login"
                              // href="https://www.cpf.gov.sg/bin/web/oidc/authenticateuser?id=member&amp;op=sp&amp;isQR=true"
                              data-analytics-click-id="GlobalHeaderLogin"
                              data-analytics-text="Login"
                              data-analytics-section="Global Header">
                              <span className="cmp-button__text">
                                {isLogin ? "Logout" : "Login"}
                              </span>
                              <span className="icons_space icon-login"></span>
                            </a>
                          </div>
                        </div>
                      )}
                      {/* Mobile */}
                      {loginRequired && isLogin && (
                        <div
                          class={`global-header-navbar__item global-header-navbar__item--login global-header-navbar__item--login-post
${isProfileOpen ? "active-bg" : ""}`}
                          onClick={() => {
                            setIsProfileOpen(!isProfileOpen);
                            if (!isProfileOpen) {
                              // Hide side bar if its open
                              if (isOpenedSideBar) {
                                clkMenuBurger();
                              }
                            }
                          }}
                          ref={window.innerWidth <= 992 ? refProfileMenuMobile : null}>
                          <div class="button">
                            <div
                              class={`postlogin-btn postlogin-btn-mobile cmp-button ${
                                isProfileOpen ? "active-bg" : ""
                              }`}>
                              <div class="postlogin-btn__member">
                                <h5 class="name-initial" style={{ marginBottom: 0 }}>
                                  {profileInfo.name ? profileInfo.name.substring(0, 1) : "-"}
                                </h5>
                              </div>

                              <div class="postlogin-btn__general postlogin-btn__disabled">
                                <span class="icons_space icon-dls-user"></span>
                              </div>
                              <ul class="profile-menu">
                                <h5 class="profile-nric" style={{ display: "none" }}></h5>
                                <h5
                                  class="cmp-text cmp-text--semi-bold profile-name"
                                  style={{ display: "block", fontSize: 16 }}>
                                  {profileInfo.name}
                                </h5>
                                <h5
                                  class="title__text title__text--regular profile-last-login"
                                  style={{ fontSize: 16 }}>
                                  {`Last login on ${profileInfo.lastLoginTime} (GMT+08:00)`}
                                </h5>
                                <div class="profile-menu__settings-button">
                                  <a
                                    href="/member/ds/account-settings"
                                    target="_self"
                                    class="cmp-button cmp-button--link"
                                    aria-label="Account settings">
                                    <span class="cmp-button__text">Account settings</span>
                                    <span class="icon-dls-line-settings"></span>
                                  </a>
                                </div>
                                <div class="separator" style={{ margin: 0, padding: 0 }}>
                                  <hr />
                                  {/* <div class="cmp-separator">
                                    <hr class="cmp-separator__horizontal-rule cmp-separator--solid--light" />
                                  </div> */}
                                </div>
                                <a
                                  class="profile-menu__logout-button cmp-button"
                                  // href="/member/logout"
                                  aria-label="Logout"
                                  onClick={logout}>
                                  <span class="cmp-button__text">Log out</span>
                                  <span class="icons_space icon-dls-logout"></span>
                                </a>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="global-header-navbar__mobile--navbar">
                        <div
                          className={`global-header-navbar__item--burger ${
                            isOpenedSideBar ? "open" : ""
                          }`}
                          onClick={clkMenuBurger}>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="global-header-navbar__menu">
                    <div className="global-header-navbar__left-menu">
                      <a
                        className="global-header-navbar__item global-header-navbar__item-active"
                        href="https://www.cpf.gov.sg/member/who-we-are"
                        target="_self"
                        data-analytics-click-id="GlobalHeaderL1Link"
                        data-analytics-text="Who we are"
                        data-analytics-section="Global Header"
                        aria-label="Who we are">
                        Who we are
                      </a>

                      <a
                        className="global-header-navbar__item global-header-navbar__item-active"
                        href="https://www.cpf.gov.sg/member/tools-and-services"
                        target="_self"
                        data-analytics-click-id="GlobalHeaderL1Link"
                        data-analytics-text="Tools and services"
                        data-analytics-section="Global Header"
                        aria-label="Tools and services">
                        Tools and services
                      </a>

                      <a
                        className="global-header-navbar__item global-header-navbar__item-active"
                        href="https://www.cpf.gov.sg/member/infohub"
                        target="_self"
                        data-analytics-click-id="GlobalHeaderL1Link"
                        data-analytics-text="Infohub"
                        data-analytics-section="Global Header"
                        aria-label="Infohub">
                        Infohub
                      </a>
                    </div>
                    <div className="global-header-navbar__right-menu">
                      <label
                        htmlFor="global-header-navbar-selector-desktop-id"
                        className="global-header-navbar__hidden">
                        {" "}
                        Choose{" "}
                      </label>
                      <div
                        ref={dropDownClose}
                        className={`global-header-navbar__item select dropdown select-single-column global-header-navbar-selector ${
                          isOpenedMember ? "select--active" : ""
                        }`}
                        onClick={handleOpenMember}
                        style={{width:200}}>
                        <div className="textbox dropdown_selected">
                          <div className="textbox__input">
                            <div className="textbox__placeholder">Member</div>
                          </div>
                        </div>
                        <ul className="dropdown_options" style={{width:200}}>
                          <li className="textbox dropdown_placeholder">
                            <div className="textbox__input">
                              <div className="textbox__placeholder">Member</div>
                            </div>
                          </li>
                          <div className="dropdown_selectable-options" style={{ height: "285px" }}>
                            <li className="dropdown_selectable">
                              <a
                                href="/member"
                                data-analytics-click-id="GlobalHeaderOptionMember"
                                data-analytics-text="Member"
                                data-analytics-section="Global Header">
                                Member
                              </a>
                            </li>
                            <li className="dropdown_selectable">
                              <a
                                href="https://www.cpf.gov.sg/employer"
                                data-analytics-click-id="GlobalHeaderOptionEmployer"
                                data-analytics-text="Employer"
                                data-analytics-section="Global Header" style={{textWrap:"nowrap"}}>
                                Employer/Business
                              </a>
                            </li>
                          </div>
                        </ul>
                      </div>
                      {/* <select
                        className="global-header-navbar__item select dropdown select-single-column global-header-navbar-selector"
                        icon-alt=""
                        icon-src=""
                        id="global-header-navbar-selector-desktop-id"
                        name="global-header-navbar-selector-desktop-name"
                        style={{ display: "none" }}
                        initialized="true"
                      >
                        <option
                          data-analytics-click-id="GlobalHeaderOptionMember"
                          data-analytics-text="Member"
                          data-analytics-section="Global Header"
                          value="/member"
                          selected=""
                        >
                          Member
                        </option>

                        <option
                          data-analytics-click-id="GlobalHeaderOptionEmployer"
                          data-analytics-text="Employer"
                          data-analytics-section="Global Header"
                          value="/employer"
                        >
                          Employer
                        </option>
                      </select> */}

                      {loginRequired && !isLogin && (
                        <div className="global-header-navbar__item global-header-navbar__item--login global-header-navbar__item--login-pre">
                          <div className="button" onClick={isLogin ? logout : login}>
                            <a
                              className="cmp-button"
                              aria-label="Login"
                              // href="https://www.cpf.gov.sg/bin/web/oidc/authenticateuser?id=member&amp;op=sp&amp;isQR=true"
                              data-analytics-click-id="GlobalHeaderLogin"
                              data-analytics-text="Login"
                              data-analytics-section="Global Header">
                              <span className="cmp-button__text">
                                {isLogin ? "Logout" : "Login"}
                              </span>
                              <span className="icons_space icon-login"></span>
                            </a>
                          </div>
                        </div>
                      )}
                      {/* Desktop */}
                      {loginRequired && isLogin && (
                        <div
                          class={`global-header-navbar__item global-header-navbar__item--login global-header-navbar__item--login-post 
                          ${isProfileOpen ? "active-bg" : ""}`}
                          onClick={() => {
                            setIsProfileOpen(!isProfileOpen);
                          }}
                          ref={window.innerWidth > 992 ? refProfileMenuDesktop : null}>
                          <div class="button">
                            <div
                              class={`postlogin-btn cmp-button ${
                                isProfileOpen ? "active-bg" : ""
                              }`}>
                              <div class="postlogin-btn__member">
                                <h5 class="name-initial" style={{ marginBottom: 0 }}>
                                  {profileInfo.name ? profileInfo.name.substring(0, 1) : "-"}
                                </h5>
                              </div>

                              <div class="postlogin-btn__general postlogin-btn__disabled">
                                <span class="icons_space icon-dls-user"></span>
                              </div>
                              <ul class="profile-menu" style={{ width: 328 }}>
                                <h5 class="profile-nric" style={{ display: "none" }}></h5>
                                <h5
                                  class="cmp-text cmp-text--semi-bold profile-name"
                                  style={{ display: "block", fontSize: 16 }}>
                                  {profileInfo.name}
                                </h5>
                                <h5
                                  class="title__text title__text--regular profile-last-login"
                                  style={{ fontSize: 16 }}>
                                  {`Last login on ${profileInfo.lastLoginTime} (GMT+08:00)`}
                                </h5>
                                <div class="profile-menu__settings-button">
                                  <a
                                    href="/member/ds/account-settings"
                                    target="_self"
                                    class="cmp-button cmp-button--link"
                                    aria-label="Account settings">
                                    <span class="cmp-button__text">Account settings</span>
                                    <span class="icon-dls-line-settings"></span>
                                  </a>
                                </div>
                                <div class="separator" style={{ margin: 0 }}>
                                  <hr style={{ margin: 0 }} />
                                  {/* <div class="cmp-separator">
                                    <hr class="cmp-separator__horizontal-rule cmp-separator--solid--light " />
                                  </div> */}
                                </div>
                                <a
                                  class="profile-menu__logout-button cmp-button"
                                  // href="/member/logout"
                                  onClick={logout}>
                                  <span class="cmp-button__text">Log out</span>
                                  <span class="icons_space icon-dls-logout"></span>
                                </a>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}

                      <div
                        className={`global-header-navbar__item global-header-navbar__item--search ${
                          isOpenSearch ? "open" : ""
                        }`}
                        data-analytics-text=""
                        data-analytics-section="Global Header"
                        data-analytics-click-id="GlobalHeaderIconSearchClose"
                        onClick={handleCloseSearch}>
                        <div className="search-icon">
                          <span className=" icon-dls-search"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`global-header-navbar__searchbar ${isOpenSearch ? "open" : ""}`}
            // style={{ overflow: isOpenSearch ? "visible" : "hidden" }}
          >
            <form
              className="aem-Grid aem-Grid--default--12 base-print-grid"
              onSubmit={handleSearch}>
              <div className="aem-GridColumn aem-GridColumn--default--12">
                <div
                  className={`search-bar animate__animated ${
                    isOpenSearch ? "animate__bounceInRight" : "animate__slideOutRight"
                  }`}
                  data-search-result-icon="icon-dls-arrow-right"
                  style={{
                    opacity: 1,
                    transform: "translate3d(0px, 0px, 0px)"
                  }}>
                  <div className="search-bar-text">
                    <input
                      id="searchBox-header-desktop"
                      aria-label="Search keywords"
                      value={searchValue}
                      onChange={handleChangeSearch}
                      placeholder="Search keywords"
                      type="text"
                      autoComplete="off"
                      style={{
                        outlineWidth: 0,
                        fontWeight: 400,
                        color: "rgb(117, 117, 117)"
                      }}
                      ref={refSearchInput}
                    />
                  </div>
                  <div className="search-bar-button">
                    <button type="submit" id="searchBox-header-desktop-button">
                      <span className="search-bar-button-text">Search</span>
                      <i className="icon-dls-search" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <div className="global-header-suggestion-container-desktop bg-white global-header--suggestion-container"></div>
              </div>
            </form>
          </div>

          <div
            className={`global-header-navbar-mobile__container global-header-navbar-mobile--member navbar-mobile-extra 
        ${menuShowCss}
        ${menuAnimateCss}
        `}
            style={{ top: 96 }}>
            <form className="search-bar" onSubmit={handleSearch}>
              <div className="search-bar-text">
                <input
                  data-search-page-url="/member/search-results"
                  placeholder="Search keywords"
                  value={searchValue}
                  onChange={handleChangeSearch}
                  type="text"
                  autoComplete="off"
                  aria-label="Search keywords"
                />
              </div>
              <div className="search-bar-button">
                <button id="searchBox-header-mobile-button" type="submit">
                  <span className="search-bar-button-text">Search</span>
                  <i className="icon-dls-search" aria-hidden="true"></i>
                </button>
              </div>
            </form>
            <div className="global-header-navbar-mobile__wrapper">
              <div className="global-header-navbar-mobile__profile-tabs">
                <h6>You are at</h6>
                <ul className="profile-tabs" style={{paddingBottom:30}}>
                  <li className="profile-tab-item" data-selected="true">
                    <a
                      aria-label="Member"
                      data-analytics-click-id="GlobalHeaderOptionMember"
                      data-analytics-text="Member"
                      data-analytics-section="Global Header"
                      href="/member">
                      <h4 className="title__text">Member</h4>
                    </a>
                  </li>
                  <li className="profile-tab-item" data-selected="false" style={{paddingLeft:15, paddingRight:15}}>
                    <a
                      aria-label="Employer"
                      data-analytics-click-id="GlobalHeaderOptionEmployer"
                      data-analytics-text="Employer"
                      data-analytics-section="Global Header"
                      href="https://www.cpf.gov.sg/employer">
                      <h4 className="title__text">Employer/<br/>Business</h4>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="global-header-navbar-mobile__top-menus">
                <div className="global-header-navbar-mobile__item">
                  <a
                    className="cmp-button cmp-button--link"
                    aria-label="Who we are"
                    href="https://www.cpf.gov.sg/member/who-we-are"
                    target="_self"
                    data-analytics-click-id="GlobalHeaderL1Link"
                    data-analytics-text="Who we are"
                    data-analytics-section="Global Header">
                    <span className="cmp-button__text">Who we are</span>
                  </a>
                </div>

                <div className="global-header-navbar-mobile__item">
                  <a
                    className="cmp-button cmp-button--link"
                    aria-label="Tools and services"
                    href="https://www.cpf.gov.sg/member/tools-and-services"
                    target="_self"
                    data-analytics-click-id="GlobalHeaderL1Link"
                    data-analytics-text="Tools and services"
                    data-analytics-section="Global Header">
                    <span className="cmp-button__text">Tools and services</span>
                  </a>
                </div>

                <div className="global-header-navbar-mobile__item">
                  <a
                    className="cmp-button cmp-button--link"
                    aria-label="Infohub"
                    href="https://www.cpf.gov.sg/member/infohub"
                    target="_self"
                    data-analytics-click-id="GlobalHeaderL1Link"
                    data-analytics-text="Infohub"
                    data-analytics-section="Global Header">
                    <span className="cmp-button__text">Infohub</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* <div
          className="global-header-navbar-mobile__container global-header-navbar-mobile--member show"
          style="height: 706px; --animate-duration:0.6s;"
        ></div> */}
        </div>
      </div>
      {/* <TimeoutModal show={showSessionTimeoutModal} 
        logout={()=>{
          setShowSessionTimeoutModal(false);
          logout();
        }} 
        continueSession={()=>{
          setShowSessionTimeoutModal(false);
          refreshToken();
        }}/> */}
    </header>
  );
}
